type PaymentStatusType = "IN_PROGRESS" | "DONE" | "ERROR";

export const PaymentPollingStatus = [
  "IN_PROGRESS",
  "DONE",
  "ERROR",
  "NOT_ENOUGH_MONEY_SBP_FIN",
  "NOT_ENOUGH_MONEY_CARD_FIN",
  "TEMPORARY_ERROR_FIN",
  "COUNT_LIMIT_EXCEEDED_SBP_FIN",
  "PAYER_BANK_REFUSAL_SBP_FIN",
  "ACCOUNT_BINDING_NOT_FOUND_SBP_FIN",
] as const;
export type PaymentPollingStatusType = (typeof PaymentPollingStatus)[number];

export type PaymentDestinationType = "ADVANCE" | "EARLY_REPAYMENT" | undefined;

export interface IMakePaymentResponse {
  id?: string;
  statusCode?: PaymentStatusType;
}

export interface ICheckPaymentStatusResponse {
  statusCode?: PaymentPollingStatusType;
}

export interface ICheckActivePaymentResponse {
  isPaymentActive?: boolean;
  amount?: string;
  currency?: string;
}
